document.addEventListener("DOMContentLoaded", function(event) { 
  let clearBtn = document.querySelector("#clear-discount-btn");
  let applyBtn = document.querySelector("#apply-discount-btn");
  let discountCodeError = document.querySelector("#discount-code-error");
  let discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
  let discountCodeValue = document.querySelector("#applied-discount-code .applied-discount-code-value");
  let discountCodeInput = document.querySelector("#discount-code-input");
  let totalCartSelector = document.querySelector(".totalCartPrice"); // Total Cart Selector to update the total amount. 
  let authorization_token;
  let actualCurrency = '€';
  
  let checkoutContainer = document.createElement('div');
  document.body.appendChild(checkoutContainer);

  if(applyBtn)
    applyBtn.addEventListener("click", function(e){
      e.preventDefault()
      applyDiscount(discountCodeInput.value);
    });

  if(clearBtn)
    clearBtn.addEventListener("click", function(e){
      e.preventDefault()
      clearDiscount();
    });

  function clearDiscount() {
    let removeDiscountCodeBtn = document.querySelector(".slidecarthq .footer-code button");
    if(!removeDiscountCodeBtn) {
      return false;
    } else {
      removeDiscountCodeBtn.click();
      discountCodeValue.innerHTML = "";
      discountCodeError.innerHTML = "";
      discountCodeInput.value = "";
      if(discountCodeWrapper) 
        discountCodeWrapper.style.display = "none";
      if(totalCartSelector) 
        totalCartSelector.innerHTML = document.querySelector(".totalCartPrice s").innerHTML;
    }
  }

  function applyDiscount(code) {
    if(applyBtn) {
      applyBtn.innerHTML = "<div class='loader'></div>";
      applyBtn.style.pointerEvents = "none";
    }
    fetch("/payments/config", {"method": "GET"}).then(function(response) { 
        return response.json() 
    }).then(function(data) {
        const checkout_json_url = '/wallets/checkouts/';
        authorization_token = btoa(data.paymentInstruments.accessToken)
        fetch('/cart.js', {}).then(function(res){
          return res.json();
        }).then(function(data) {
          let body = {"checkout": { "country": Shopify.country,"discount_code": code,"line_items": data.items, 'presentment_currency': Shopify.currency.active } }
          fetch(checkout_json_url, {
            "headers": {
              "accept": "*/*", "cache-control": "no-cache",
              "authorization": "Basic " + authorization_token,
              "content-type": "application/json, text/javascript",
              "pragma": "no-cache", "sec-fetch-dest": "empty",
              "sec-fetch-mode": "cors", "sec-fetch-site": "same-origin"
            },
            "referrerPolicy": "strict-origin-when-cross-origin",
            "method": "POST", "mode": "cors", "credentials": "include",
            "body": JSON.stringify(body)
          }).then(function(response) { 
            return response.json() 
          }).then(function(data) {
            if(data.checkout && data.checkout.applied_discounts.length > 0) {
              console.log(data.checkout)
              actualCurrency = data.checkout.currency_format.symbol;
              window.SLIDECART_APPLY_DISCOUNT(code)
              if(discountCodeWrapper) 
                discountCodeWrapper.style.display = "inline";
              if(discountCodeError) 
                discountCodeError.innerHTML = "";
              if(discountCodeValue)
                discountCodeValue.innerHTML = data.checkout.applied_discounts[0].title; 
              if(totalCartSelector) 
                totalCartSelector.innerHTML = "<s style='color: rgb(var(--text-color) / .65);font-size: 90%;margin-right: 5px;'>" + data.checkout.total_line_items_price + " " + actualCurrency + "</s>" + data.checkout.total_price + " <span id='discount-code-currency'>" +actualCurrency+"</span>";
            } else {
              if(discountCodeValue) 
                discountCodeValue.innerHTML = "";
              if(data.errors && data.errors.discount_code && discountCodeError)
                discountCodeError.innerHTML = data.errors.discount_code[0].message;
            }
          }).finally(function(params) {
            if(applyBtn){
              applyBtn.innerHTML = "APPLIQUER";
              applyBtn.style.pointerEvents = "all";
            }
          });
      });
    });
  }
});